/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MessageSourceAccessor } from './MessageSourceAccessor';
import {
    MessageSourceAccessorFromJSON,
    MessageSourceAccessorFromJSONTyped,
    MessageSourceAccessorToJSON,
    MessageSourceAccessorToJSONTyped,
} from './MessageSourceAccessor';
import type { MapObject } from './MapObject';
import {
    MapObjectFromJSON,
    MapObjectFromJSONTyped,
    MapObjectToJSON,
    MapObjectToJSONTyped,
} from './MapObject';

/**
 * 
 * @export
 * @interface RedirectView
 */
export interface RedirectView {
    /**
     * 
     * @type {object}
     * @memberof RedirectView
     */
    logger?: object;
    /**
     * 
     * @type {object}
     * @memberof RedirectView
     */
    applicationContext?: object;
    /**
     * 
     * @type {MessageSourceAccessor}
     * @memberof RedirectView
     */
    messageSourceAccessor?: MessageSourceAccessor | null;
    /**
     * 
     * @type {object}
     * @memberof RedirectView
     */
    servletContext?: object;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    contentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    requestContextAttribute?: string | null;
    /**
     * 
     * @type {MapObject}
     * @memberof RedirectView
     */
    staticAttributes?: MapObject;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    exposePathVariables?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    exposeContextBeansAsAttributes?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RedirectView
     */
    exposedContextBeanNames?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    beanName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    url?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    contextRelative?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    http10Compatible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    exposeModelAttributes?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    encodingScheme?: string | null;
    /**
     * 
     * @type {object}
     * @memberof RedirectView
     */
    statusCode?: object;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    expandUriTemplateVariables?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    propagateQueryParams?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RedirectView
     */
    hosts?: Array<string> | null;
}

/**
 * Check if a given object implements the RedirectView interface.
 */
export function instanceOfRedirectView(value: object): value is RedirectView {
    return true;
}

export function RedirectViewFromJSON(json: any): RedirectView {
    return RedirectViewFromJSONTyped(json, false);
}

export function RedirectViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedirectView {
    if (json == null) {
        return json;
    }
    return {
        
        'logger': json['logger'] == null ? undefined : json['logger'],
        'applicationContext': json['applicationContext'] == null ? undefined : json['applicationContext'],
        'messageSourceAccessor': json['messageSourceAccessor'] == null ? undefined : MessageSourceAccessorFromJSON(json['messageSourceAccessor']),
        'servletContext': json['servletContext'] == null ? undefined : json['servletContext'],
        'contentType': json['contentType'] == null ? undefined : json['contentType'],
        'requestContextAttribute': json['requestContextAttribute'] == null ? undefined : json['requestContextAttribute'],
        'staticAttributes': json['staticAttributes'] == null ? undefined : MapObjectFromJSON(json['staticAttributes']),
        'exposePathVariables': json['exposePathVariables'] == null ? undefined : json['exposePathVariables'],
        'exposeContextBeansAsAttributes': json['exposeContextBeansAsAttributes'] == null ? undefined : json['exposeContextBeansAsAttributes'],
        'exposedContextBeanNames': json['exposedContextBeanNames'] == null ? undefined : json['exposedContextBeanNames'],
        'beanName': json['beanName'] == null ? undefined : json['beanName'],
        'url': json['url'] == null ? undefined : json['url'],
        'contextRelative': json['contextRelative'] == null ? undefined : json['contextRelative'],
        'http10Compatible': json['http10Compatible'] == null ? undefined : json['http10Compatible'],
        'exposeModelAttributes': json['exposeModelAttributes'] == null ? undefined : json['exposeModelAttributes'],
        'encodingScheme': json['encodingScheme'] == null ? undefined : json['encodingScheme'],
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'expandUriTemplateVariables': json['expandUriTemplateVariables'] == null ? undefined : json['expandUriTemplateVariables'],
        'propagateQueryParams': json['propagateQueryParams'] == null ? undefined : json['propagateQueryParams'],
        'hosts': json['hosts'] == null ? undefined : json['hosts'],
    };
}

export function RedirectViewToJSON(json: any): RedirectView {
    return RedirectViewToJSONTyped(json, false);
}

export function RedirectViewToJSONTyped(value?: RedirectView | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'logger': value['logger'],
        'applicationContext': value['applicationContext'],
        'messageSourceAccessor': MessageSourceAccessorToJSON(value['messageSourceAccessor']),
        'servletContext': value['servletContext'],
        'contentType': value['contentType'],
        'requestContextAttribute': value['requestContextAttribute'],
        'staticAttributes': MapObjectToJSON(value['staticAttributes']),
        'exposePathVariables': value['exposePathVariables'],
        'exposeContextBeansAsAttributes': value['exposeContextBeansAsAttributes'],
        'exposedContextBeanNames': value['exposedContextBeanNames'],
        'beanName': value['beanName'],
        'url': value['url'],
        'contextRelative': value['contextRelative'],
        'http10Compatible': value['http10Compatible'],
        'exposeModelAttributes': value['exposeModelAttributes'],
        'encodingScheme': value['encodingScheme'],
        'statusCode': value['statusCode'],
        'expandUriTemplateVariables': value['expandUriTemplateVariables'],
        'propagateQueryParams': value['propagateQueryParams'],
        'hosts': value['hosts'],
    };
}

